// Normal type
/* use the state type LOG_IN_USER LOG_OUT_USER LOG_IN_ERROR */


export const LOG_IN_USER = 'LOG_IN_USER';
export const LOG_OUT_USER = 'LOG_OUT_USER';

// Errors type
export const LOG_IN_ERROR = 'LOG_IN_ERROR';

